import { Info } from "lucide-react";
import type { InfoModalProps } from "../types/commonTypes";


export default function InfoModal({ isOpen, title, message, onClose, buttonText = "OK" }: InfoModalProps) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 backdrop-blur-sm">
            <div className="bg-white border border-gray-200 rounded-xl shadow-2xl w-[400px] p-6 animate-scale-in">
                <div className="flex items-center justify-center mb-4">
                    <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                        <Info className="w-6 h-6 text-primary" />
                    </div>
                </div>

                <h3 className="text-xl font-bold text-gray-900 text-center mb-2">
                    {title}
                </h3>

                <p className="text-gray-600 text-center mb-6 leading-relaxed">
                    {message}
                </p>

                <div className="flex justify-center">
                    <button
                        onClick={onClose}
                        className="w-full px-4 py-3 bg-primary text-white rounded-xl hover:bg-blue-700 transition-colors font-semibold shadow-sm"
                    >
                        {buttonText}
                    </button>
                </div>
            </div>
        </div>
    );
}
